import React, { RefObject } from 'react';
import { useScrollReveal } from '../../../hooks';
import mark from '../brand/onehot-q.png';
import { LINKS } from '../content';
import { Band, reveal } from './Band';

// The page closes on the product itself: the console's own lockup, large, where the homepage's
// close has its mesh, with a short call to start beside it. On a wide screen the lockup holds
// the right and the call the left; narrower, the lockup leads and the call follows beneath.
// The buttons are the homepage close's.

const primary =
  'text-button font-body bg-foreground text-background px-6 py-3 rounded-full hover:bg-foreground/70 hover:shadow-lg transition-all duration-300';
const secondary =
  'text-button font-body border border-foreground/30 text-foreground/70 px-6 py-3 rounded-full hover:border-foreground hover:text-foreground hover:bg-foreground/10 hover:shadow-md transition-all duration-300';

// Set as the console's sidebar sets it (onehot.css): Sqwish Labs over OneHot, the mark beside it.
function Lockup({ className, style }: { className: string; style: React.CSSProperties }) {
  return (
    <div className={`oh-lockup ${className}`} style={style}>
      <img className="oh-lockup-mark" src={mark} width={256} height={252} alt="" />
      <span className="oh-lockup-maker">Sqwish Labs</span>
      <span className="oh-lockup-name">OneHot</span>
    </div>
  );
}

export function StartSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });
  return (
    <Band id="contact" tone="secondary">
      <div ref={ref as RefObject<HTMLDivElement>} className="oh-start">
        <Lockup className={reveal(isVisible)} style={{ animationDelay: '0.05s' }} />
        <div className="oh-start-call">
          <h2
            className={`font-display text-heading md:text-display-sm text-foreground text-balance ${reveal(isVisible)}`}
            style={{ animationDelay: '0.15s' }}
          >
            Ask your first question.
          </h2>
          <div className={`oh-start-actions mt-8 flex flex-wrap gap-4 ${reveal(isVisible)}`} style={{ animationDelay: '0.25s' }}>
            <a href={LINKS.console} target="_blank" rel="noopener noreferrer" className={`${primary} uppercase`}>Try OneHot</a>
            <a href={LINKS.playground} target="_blank" rel="noopener noreferrer" className={secondary}>Try the playground</a>
          </div>
        </div>
      </div>
    </Band>
  );
}

export default StartSection;
